<template>
  <tinymce-editor :init="tinymceSettings"
                  :value="value"
                  @input="handleInput"/>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import tinymce from 'tinymce/tinymce'
import 'tinymce/themes/silver'
import 'tinymce/themes/mobile'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/autoresize'
import 'tinymce/plugins/code'
import 'tinymce/plugins/table'
import 'tinymce/plugins/link'
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/paste'
import TinymceEditor from '@tinymce/tinymce-vue'
import {
  ALLOWED_FONT_FAMILIES,
  ALLOWED_FONT_SIZES,
  DEFAULT_FONT_FAMILY,
  DEFAULT_FONT_SIZE,
  LEGACY_ALLOWED_FONT_SIZES,
  sanitizeTypographyStyles,
} from '../helpers/sanitize_typography_styles'

const editorFontSizeStyles = [...ALLOWED_FONT_SIZES, ...LEGACY_ALLOWED_FONT_SIZES]
  .map(size => `html body.mce-content-body [style*="font-size: ${size}"], html body.mce-content-body [style*="font-size:${size}"] { font-size: ${size} !important; }`)
  .join(' ')

export default {
  name: 'prk-editor',
  components: { TinymceEditor },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      tinymceSettings: {
        content_style: `body { font-family: ${DEFAULT_FONT_FAMILY}; font-size: ${DEFAULT_FONT_SIZE} !important; } p { margin: 0 0 14px 0 } ${editorFontSizeStyles}`,
        content_css: '/tinymce/skins/content/default/content.css',
        skin_url: '/tinymce/skins/ui/oxide/',
        height: 150,
        plugins: 'autoresize code lists advlist link table paste',
        paste_as_text: true,
        font_formats: ALLOWED_FONT_FAMILIES.map(font => `${font}=${font}`).join(';'),
        fontsize_formats: ALLOWED_FONT_SIZES.join(' '),
        toolbar: 'code | bold italic underline hr forecolor backcolor | link unlink | undo redo | \n' +
            '            bullist numlist | outdent indent | alignleft aligncenter | alignright alignjustify |',
        menubar: 'tools insert edit table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
        branding: false,
        statusbar: false,
        invalid_elements: 'script',
        setup: editor => {
          editor.on('BeforeSetContent', event => {
            event.content = this.sanitizeContent(event.content)
          })
          editor.on('GetContent', event => {
            event.content = this.sanitizeContent(event.content)
          })
        },
      },
    }
  },
  methods: {
    handleInput (content) {
      this.$emit('input', this.sanitizeContent(content))
    },
    sanitizeContent (content) {
      return sanitizeTypographyStyles(content)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/stylesheets/vars';

</style>
